// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__x0vYd","label":"style_label__CiTpq","value":"style_value__KDZs2","icon":"style_icon__Ohq8M","content":"style_content__UpaI_"};